import React from 'react';
import Typography from '@mui/material/Typography';

interface PageTitleProps {
  variant: 'default' | 'minimal';
  children: React.ReactNode;
}

function PageTitle({ variant, children }: PageTitleProps) {
  const isDefault = variant === 'default';
  return (
    <Typography variant={isDefault ? 'h1' : 'h6'} id="main-content" component="h1">
      {children}
    </Typography>
  );
}

export default PageTitle;
